import { createCourseManagerConfig } from '@nsc/simple-lms/client/course-config.js';
import { html } from 'lit';
import { FieldEngineerEnrollmentManager } from '../components/field-engineer-enrollment-manager.js';

export const courseManagerConfig = createCourseManagerConfig({
  enrollmentManagerComponent: ({ courseId }) => html`${FieldEngineerEnrollmentManager({ courseId })}`,
});

export { availabilityManagerConfig } from './availability-config.js';
export { customerManagerConfig } from './customer-config.js';
export { fieldEngineerManagerConfig } from './field-engineer-config.js';
export { createPartnerCompanyManagerConfig } from './partner-company-config.js';
